/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Upload_RequiredInputs */

const cs_pm_upload_required = /** @type {(inputs: Pm_Upload_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U tohoto portálu nahrajte export inzerátů.`)
};

const en_pm_upload_required = /** @type {(inputs: Pm_Upload_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a listing export for this portal.`)
};

/**
* | output |
* | --- |
* | "Upload a listing export for this portal." |
*
* @param {Pm_Upload_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_upload_required = /** @type {((inputs?: Pm_Upload_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Upload_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_upload_required(inputs)
	return cs_pm_upload_required(inputs)
});